import { separateURL } from '@/utils/urls';

const getSailthru = () => {
    // @ts-expect-error - Sailthru is injected by third-party script, not typed on Window
    return typeof window !== 'undefined' ? window.Sailthru : undefined;
};

export const sailthruTrack = (url: string) => {
    const sailthru = getSailthru();
    if (sailthru) {
        const path = separateURL(url).path ? separateURL(url).path : url;
        const finalURL = `https://www.liveauctioneers.com${path}`;
        try {
            sailthru.track('pageview', {
                url: finalURL,
            });
        } catch (e) {
            // sailthru tracking errors are non-critical
        }
    }
};
